export const drinkstypes = {
    MANGO_INCREASE : 'MANGO_INCREASE',
    MANGO_DECREASE : 'MANGO_DECREASE',
    COLD_COFFEE_INCREASE : 'COLD_COFFEE_INCREASE',
    COLD_COFFEE_DECREASE : 'COLD_COFFEE_DECREASE',
    COFFEE_INCREASE : 'COFFEE_INCREASE',
    COFFEE_DECREASE : 'COFFEE_DECREASE',
    PEPSI_INCREASE : 'PEPSI_INCREASE',
    PEPSI_DECREASE : 'PEPSI_DECREASE',
    CLEAR_ALL_DRINKS : 'CLEAR_ALL_DRINKS'
}